import { RemoteAgentConnectionStatus } from '~src/settings/types/ISiteAdminBridgeSettings';

import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IRemoteAgentConnectionStatus {
  agentName: string;
  connectionStatus: RemoteAgentConnectionStatus;
}

export interface IGetSiteRemoteAgentsConnectionStatusParams {
}

export interface IGetSiteRemoteAgentsConnectionStatusResult {
  agents: IRemoteAgentConnectionStatus[];
}

export class GetSiteRemoteAgentsConnectionStatusRequest
  extends Request<IGetSiteRemoteAgentsConnectionStatusParams, IGetSiteRemoteAgentsConnectionStatusResult> {

  constructor(params: IGetSiteRemoteAgentsConnectionStatusParams) {
    super('getSiteRemoteAgentsConnectionStatus', params);
  }
}
